import React from 'react'

const Video = ({ hScreenHeight, HomeVideo }) => {
    return (
        <div style={{ height: hScreenHeight }} className='absolute h-full w-full z-10'>
            <div className='absolute object-cover h-full w-full bg-black/80 md:bg-black/60 z-20'></div>
            <video
                className={`h-full w-full object-cover`}
                autoPlay
                playsInline
                muted
                loop
            ><source src={HomeVideo} type='video/mp4'></source></video>
        </div>
    )
}

export default Video